import * as THREE from 'three';

export class TouchIndicator {
  readonly mesh: THREE.Mesh;
  private visible = false;

  constructor(scene: THREE.Scene) {
    const geo = new THREE.RingGeometry(0.08, 0.14, 24);
    const mat = new THREE.MeshBasicMaterial({
      color: 0xffffff,
      transparent: true,
      opacity: 0.7,
      side: THREE.DoubleSide,
    });
    this.mesh = new THREE.Mesh(geo, mat);
    this.mesh.rotation.x = -Math.PI / 2;
    this.mesh.visible = false;
    scene.add(this.mesh);
  }

  showAt(worldPoint: THREE.Vector3): void {
    this.mesh.position.set(worldPoint.x, worldPoint.y + 0.02, worldPoint.z);
    this.mesh.visible = true;
    this.visible = true;
  }

  hide(): void {
    this.mesh.visible = false;
    this.visible = false;
  }

  isVisible(): boolean {
    return this.visible;
  }

  dispose(): void {
    this.mesh.geometry.dispose();
    (this.mesh.material as THREE.Material).dispose();
    this.mesh.parent?.remove(this.mesh);
  }
}
